import 'whatwg-fetch';
import "url-search-params-polyfill";
//import 'dom4';
//import 'promise-polyfill/src/polyfill';
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});
  
export default app;